import { parseJSON } from 'date-fns';
import { Subject } from 'rxjs';

import { Component, OnDestroy } from '@angular/core';

import { SnCurrentOrganization } from '@lib/auth/services';
import { snDetailExpand, snFadeIn, snFadeOut } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';
import { LprCameraModel } from '@lib/vehicle-intelligence/api';

@Component({
  selector: 'fs-lpr-camera-table',
  templateUrl: './lpr-camera-table.component.html',
  styleUrls: ['./lpr-camera-table.component.scss'],
  animations: [snFadeIn, snFadeOut, snDetailExpand],
})
export class LprCameraTableComponent
  extends SnTableBaseComponent<LprCameraModel>
  implements OnDestroy
{
  public lprDownMinutes: number;

  private readonly _expanded = [];

  private readonly _destroy$ = new Subject();

  constructor(private readonly _currentOrg: SnCurrentOrganization) {
    super();
    this.lprDownMinutes = this._currentOrg.settings.lprDownMinutes;
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public trackBy(index: number, item: LprCameraModel): any {
    return item.id;
  }

  public isExpanded(id: string): boolean {
    return this._expanded.indexOf(id) > -1;
  }

  public toggleExpanded(item: LprCameraModel): void {
    if (this.isExpanded(item.id)) {
      this._expanded.splice(this._expanded.indexOf(item.id), 1);
    } else {
      this._expanded.push(item.id);
    }
  }

  public formatDate(item: LprCameraModel): Date {
    return parseJSON(item.lastEvent);
  }

  public getCameraIcon(item: LprCameraModel): any {
    switch (true) {
      case item.provider?.toString() === 'FLOCK_SAFETY':
        return { makeIcon: 'Icon_FS', hasIcon: true };
      case item.provider?.toString().includes('GENETEC'):
      case item.provider?.toString().includes('GENETEC_SHARP3'):
      case item.provider?.toString().includes('GENETEC_SHARP5'):
        return { makeIcon: 'Icon_Genetec', hasIcon: true };
      case item.provider?.toString().includes('VIGILANT'):
        return { makeIcon: 'Icon_Vigilant', hasIcon: true };
      case item.provider?.toString().includes('REKOR'):
        return { makeIcon: 'Icon_Rekor', hasIcon: true };
      default:
        return { makeIcon: item.provider, hasIcon: false };
    }
  }
}
